/**
 * Client-side mirror of the server-rendered SEO head.
 * Generated from backend/seo/site.js — run `node backend/scripts/gen-seo.js`
 * after editing page titles, descriptions or FAQs. Never edit by hand.
 */
import generated from "@/content/seo.generated.json";

export const HEADS = generated.heads;
export const SITE_URL = "https://lanvaus.com";
export const SITE_NAME = "Lanvaus";
export const OG_IMAGE = `${SITE_URL}/assets/og-lanvaus.png`;

export const getHead = (pathname) => HEADS[pathname] || null;

export const faqsFor = (pathname) => HEADS[pathname]?.faqs || [];

export const NOT_FOUND_HEAD = {
  title: "Page Not Found | Lanvaus",
  description:
    "The page you are looking for does not exist. Browse Lanvaus cybersecurity services, insights and resources instead.",
  keywords: "",
  canonical: `${SITE_URL}/404`,
  robots: "noindex, follow",
  ogType: "website",
  ogImage: OG_IMAGE,
  jsonLd: null,
  faqs: [],
};

export const ADMIN_HEAD = {
  title: "Lanvaus Admin",
  description: "Lanvaus content administration.",
  keywords: "",
  canonical: `${SITE_URL}/admin`,
  robots: "noindex, nofollow",
  ogType: "website",
  ogImage: OG_IMAGE,
  jsonLd: null,
  faqs: [],
};

/** Head for a blog post, mirroring backend headForPost(). */
export const headForPost = (post) => ({
  title: post.metaTitle || `${post.title} | Lanvaus`,
  description: post.metaDescription || post.excerpt,
  keywords: post.keywords || "",
  canonical: `${SITE_URL}/insights/${post.slug}`,
  robots: "index, follow, max-image-preview:large, max-snippet:-1",
  ogType: "article",
  ogImage: post.coverImage || OG_IMAGE,
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BlogPosting",
        headline: post.title,
        description: post.metaDescription || post.excerpt,
        image: post.coverImage || OG_IMAGE,
        url: `${SITE_URL}/insights/${post.slug}`,
        datePublished: post.publishedAt,
        dateModified: post.updatedAt || post.publishedAt,
        inLanguage: "en-IN",
        author: { "@type": "Person", name: post.author || "Lanvaus Security Team" },
        publisher: { "@id": `${SITE_URL}/#organization` },
        keywords: post.keywords,
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          ["Home", "/"],
          ["Insights", "/insights"],
          [post.title, `/insights/${post.slug}`],
        ].map(([name, path], i) => ({
          "@type": "ListItem",
          position: i + 1,
          name,
          item: `${SITE_URL}${path}`,
        })),
      },
      ...(post.faqs?.length
        ? [
            {
              "@type": "FAQPage",
              mainEntity: post.faqs.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            },
          ]
        : []),
    ],
  },
  faqs: post.faqs || [],
});
